import React from 'react';
import Notfound from '../assets/images/Notfound.png';
import PropTypes from 'prop-types';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (error.name === 'ChunkLoadError') {
      // Reload the page to try reloading missing chunk
      window.location.reload();
    }
    // You can also log the error to an error reporting service
    //   logErrorToMyService(error, errorInfo);
    console.error('Error Boundary Caught an Error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  handleRetry = () => {
    // Reset error state and reload component
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.reload(); // Optional: refreshes the page
  };

  NoMatchPage = () => {
    document.body.style.height = '100%';
    return <iframe src={Notfound} title="Error" name="error" data-testid="error-boundary-img" />;
  };
  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.NoMatchPage();
    }

    return this.props.children;
  }
}
export default ErrorBoundary;

ErrorBoundary.propTypes = {
  children: PropTypes.any,
};
